import React from 'react'
import { hydrate, render } from 'react-dom';

// Router
import AppRouter from './routers/AppRouter'

// CSS
import '../node_modules/bulma/css/bulma.css'
import './App.css'

// NOTA: AOS está causando un conflicto en la carga de contenido
// donde se lo está aplicando, al pasar de ES/EN o viceversa
// no se visualiza dicho contenido, por ello se lo está desactivando.

// import './aos.css'
// import AOS from 'aos'

// AOS.init({
//   disable: 'phone'
// });

const rootElement = document.getElementById('root');

if (rootElement.hasChildNodes()) {
  hydrate (<AppRouter/>, rootElement);
} else {
  render(<AppRouter />, rootElement);
}